import { useMemo } from 'react';
import { Option, PayoutRuleType, ProcessingRuleItem, useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, IProcessingRuleDto } from '@/dtos';
import { IProcessingTierDto } from '@/dtos';

import { useSortTiers as sortTiers } from '../hooks';

export const QUERY_KEY = 'GET_PROCESSING_RULE_BY_ID';
export default (ruleId?: string, enabled = true) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, ruleId, enabled],
    ruleId ? () => api.get<IProcessingRuleDto>(API_URL.PROCESSING_RULES_BY_ID(ruleId)) : () => null,
    {
      enabled: enabled && !!ruleId,
    }
  );

  const formatedData = useMemo(() => {
    const item = data?.data;
    const formatedItem: ProcessingRuleItem = {
      id: _.toString(item?.id),
      name: item?.name || '',
      organizationType: item?.organization_type,
      editable: item?.editable,
      tiers: sortTiers(item?.tiers || [])?.map((tier: IProcessingTierDto) => ({
        id: _.toString(tier.id),
        name: tier.name || '',
        payoutDefinition: {
          id: _.toString(tier.payout_definition?.id),
          name: tier.payout_definition?.name || '',
        },
        isSendTriggerNotification: tier.is_send_trigger_notification,
        triggers: tier.triggers,
        tierTriggers: (tier.tier_triggers || []).map((t) => ({
          id: _.toString(t.id),
          name: t.name,
          triggerCategoryType: t.trigger_category_type,
        })),
        nextTierId: tier.next_tier_id ?? null,
        displayName: tier?.display_name,
        planId: _.toString(tier?.plan_id),
        planName: tier?.plan_name,
        payoutRuleType: tier?.payout_rule_type as string as PayoutRuleType,
        planIdsForCardPurseLock: tier?.plan_ids_for_card_purse_lock?.map(String) || [],
        planNamesForCardPurseLock: tier?.plan_names_for_card_purse_lock || [],
      })),
    };
    return formatedItem;
  }, [data]);

  const option = useMemo<Option[]>(() => {
    const item = data?.data;
    if (!item) return [];
    return [
      {
        key: _.toString(item?.id),
        value: `${item?.name}`,
        name: item?.name,
      },
    ];
  }, [data]);

  return {
    isLoading,
    rule: formatedData,
    ruleOption: option,
  };
};
